const SidebarFooter = () => {
    return(
        <div className="sidebar-footer">
            <div>Versão 1.5.2</div>
            <div>© Smart Olfativos</div>
        </div>
    )
}

export default SidebarFooter;